module.exports = {
    components: {
        accordion: require("src/components/accordion"),
        badge: require("src/components/badge"),
        banner: require("src/components/banner"),
        button: require("src/components/button"),
        checkbox: require("src/components/checkbox"),
        radio_button: require("src/components/radio_button"),
        inputs_group: require("src/components/inputs_group"),
        dropdown: require("src/components/dropdown"),
        header: require("src/components/header"),
        icon: require("src/components/icon"),
        icon_button: require("src/components/icon_button"),
        inline_message: require("src/components/inline_message"),
        input: require("src/components/input"),
        link: require("src/components/link"),
        nav_toggle: require("src/components/nav_toggle"),
        pagination: require("src/components/pagination"),
        table: require("src/components/table"),
        tabs: require("src/components/tabs"),
        tooltip: require("src/components/tooltip")
    },
    tokens: {
        // todo simone to be refined
        // those style may not be exported since they all included some components require()
        index: require("src/tokens/index.css"),
        shared_components_style: require("src/tokens/shared_components_style.css")
        // typography: require("src/tokens/typography.css"),
        // spacing: require("src/tokens/spacing.css"),
        // shapes: require("src/tokens/shapes.css"),

    },
    foundation: {
        logos: {
            swift_dark_green: require("src/foundations/logos/Swift_Logo_RGB_Dark_Green.svg"),
            swift_peppermint: require("src/foundations/logos/Swift_Logo_RGB_Peppermint.svg"),
            swift_white: require("src/foundations/logos/Swift_Logo_RGB_White.svg")
        }
    }
};
